import React from 'react';

const CentralName = () => {
    return (
        <div className="center-container">
            <p className="central-name">A-LINE TATTOO</p>
        </div>
    );
};

export default CentralName;